import React, { Component } from "react";
import { connect } from "react-redux";
import service from "../../../services";

class Modal extends Component {
  constructor() {
    super();
    this.apiserve = new service();
  }

  submit = () => {
    const { channelId, chat, question, type } = this.props;
    const data = {
      channelId: channelId,
      chatStatus: type === "chat" ? (chat === 1 ? 2 : 1) : chat,
      questionStatus: type === "question" ? (question === 1 ? 2 : 1) : question
    };
    this.apiserve.sendevent("admin|screenerChangeChannelStatus", data);
    this.props.close();
  };

  render() {
    const { chat, question, type } = this.props;
    return (
      <div className="screening_popup">
        <div className="screening_popup_inner">
          <div className="screening_popup_header">
            <span className="close_modal pointer" onClick={() => this.props.close()}>
              <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z"
                  fill="black" />
              </svg>
            </span>
          </div>
          <div className="screening_popup_content">
            <div className="message mb_25 text_center">
              {type === "chat" && <p>Do you want to turn {`${chat === 1 ? 'off': 'on'}`} the CHAT for this screening?</p>}
              {type === "question" && <p>Do you want to turn {`${question === 1 ? 'off': 'on'}`} LIVE Q&A for this screening?</p>}
            </div>
            <div className="field_row">
              <button onClick={() => this.props.close()}>NO</button>
              <button className="active" type="button" onClick={this.submit}>YES</button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  channelId: state.scannerLoginData.channelId
});


export default connect(mapStateToProps)(Modal);